import React from "react";
import { Box, createTheme, Tab, Tabs, ThemeProvider } from "@mui/material";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import "./tabComponent.css";
const TabsComponent = ({ tabs, value, onChange }) => {
  localStorage.setItem("tabValue", value);

  const theme = createTheme({
    components: {
      MuiTab: {
        styleOverrides: {
          root: {
            color: "#757575",
            "&.Mui-selected": {
              color: "#1976D2",
            },
          },
        },
      },
      MuiTabs: {
        styleOverrides: {
          indicator: {
            backgroundColor: "#FFFFFF",
          },
        },
      },
      MuiTabPanel: {
        styleOverrides: {
          root: {
            backgroundColor: "#FFFFFF",
            padding: "16px",
          },
        },
      },
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={onChange} aria-label="custom tabs">
              {tabs.map((tab) => (
                <Tab
                  key={tab.value}
                  label={tab.label}
                  value={tab.value}
                  className="tab-name"
                />
              ))}
            </TabList>
          </Box>
          {tabs.map((tab) => (
            <TabPanel key={tab.value} value={tab.value} className="tab-panel">
              {tab.content}
            </TabPanel>
          ))}
        </TabContext>
      </Box>
    </ThemeProvider>
  );
};

export default TabsComponent;
